import { Injectable, inject } from '@angular/core';
import { AuthService } from './components/shared/services/auth.service';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private authService = inject(AuthService);

  initialize(): Promise<boolean> {
    return new Promise((resolve) => {
      // Wait for auth service to initialize
      this.authService.isInitialized$
        .pipe(
          filter(initialized => initialized === true),
          take(1)
        )
        .subscribe(() => {
          resolve(true);
        });
    });
  }
}
